import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
export const WindowPopup = ({ url, children, onClose, ...restProps }) => {
    const [root, setRoot] = useState(null);
    const windowToOpen = useRef(null);
    const timerId = useRef();
    useEffect(() => {
        const div = document.createElement('div');
        setRoot(div);
        timerId.current = window.setInterval(() => {
            var _a;
            if ((_a = windowToOpen.current) === null || _a === void 0 ? void 0 : _a.closed) {
                window.clearInterval(timerId.current);
                if (onClose)
                    onClose();
            }
        }, 1000);
        return () => {
            window.clearInterval(timerId.current);
        };
    }, []);
    useEffect(() => {
        var _a;
        if (!root) {
            return;
        }
        const width = restProps.width || Math.max(640, window.innerWidth / 3);
        const height = restProps.height || Math.max(640, window.innerHeight / 3);
        const left = restProps.left || Math.max(0, window.innerWidth / 2 - width / 2);
        const top = restProps.top || Math.max(0, window.innerHeight / 2 - height / 2);
        windowToOpen.current = window.open(url, '_blank', `popup=true,width=${width},height=${height},top=${top},left=${left}`);
        (_a = windowToOpen.current) === null || _a === void 0 ? void 0 : _a.document.body.appendChild(root);
        return () => { var _a; return (_a = windowToOpen.current) === null || _a === void 0 ? void 0 : _a.close(); };
    }, [root]);
    return root && createPortal(children, root);
};
